export enum EventWidgetSizeBreakPoint {
  Mobile = 0,
  Tablet = 680,
  DeskTop = 1044,
  Large = 1428,
}

export enum EventWidgetSize {
  Mobile = "mobile",
  Tablet = "tablet",
  Desktop = "desktop",
  Large = "large",
}
